import React from 'react';

const GroomHrManagmentApp = () => {
  return (
    <div style={{ width: '100%', height: '100vh', overflow: 'hidden' }}>
      <iframe
        src="/projectList/groom.html"
        title="Groom Hr Management App"
        style={{ width: '100%', height: '100%', border: 'none' }}
      />
     
    </div>
    
  );
}

export default GroomHrManagmentApp;